export default __webpack_public_path__ + "static/6-95df13476938623f7452479c81839dd4.png";